import { GET, PATCH, POST } from "../../helper/collaticaRestFunctions";
export const updateOrgUserRols = async (
  orgId: any,
  orgUserId: any,
  data: any
) => {
  const path = `/orgs/${orgId}/users/${orgUserId}/update_role`;
  return await PATCH({ apiUri: path, data })
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
